export const LEGAL_POINTS = 5;
